import React, { FunctionComponent } from 'react';
import { Button } from '../button/Button';
import ChevronIcon from '../icons/ChevronIcon';
import CircleXIcon from '../icons/CircleXIcon';
import Typography from '../typography/Typography';
import './errorScreen.scss';

type ErrorScreenProps = {
  onClick: () => void;
  title?: string;
  text?: string;
  buttonLabel?: string;
}

const ErrorScreen: FunctionComponent<ErrorScreenProps> = ({
  onClick,
  title = 'Oops!',
  text = 'This page could not be loaded.',
  buttonLabel = 'Go Back',
}) => (
  <div className="d-flex align-items-center justify-content-center flex-column error-screen">
    <CircleXIcon color="red5" width={35} className="margin-bottom-25" />
    <Typography variant="h5" color="asphalt6" className="bold margin-bottom-15">
      { title }
    </Typography>
    <Typography variant="body1" color="asphalt6" className="bold margin-bottom-32">
      { text }
    </Typography>
    <Button
      variant="info"
      priority="primary"
      label={buttonLabel}
      className="go-back-button"
      icon={<ChevronIcon color="light" direction="left" width={14} />}
      onClick={onClick}
    />
  </div>
);

export default ErrorScreen;
